import { createContext } from 'react';

import type { IConfig } from '~/config/types';

/**
 * The AppStateContext is temporarly used to provide the app state to the app.
 * It will be replaced by a more robust state management solution in the future.
 */
export type IConfigurationContext = IConfig;

export const ConfigurationContext = createContext<IConfigurationContext | null>(null);
